// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jw-chip-buttons{display:flex;text-align:center}.jw-chip-buttons .jw-chip-button{width:100%;border-inline-end-width:0!important;margin-inline-end:0;margin-bottom:0}.jw-chip-buttons .jw-chip-button:last-child{border-inline-end-width:1px!important}", ""]);
// Exports
module.exports = exports;
